import { takeEvery } from 'redux-saga/effects';
import setLocale from './setLocale';
import { INIT_APP, SET_LOCALE } from '../actions';
import { SYSTEM_MODULE } from '../../../configs/moduleNames';

export default function* watchSystem() {
  yield takeEvery(SYSTEM_MODULE + SET_LOCALE, setLocale);
}
